import { createFileRoute, redirect } from '@tanstack/react-router';
import { DEFAULT_PLANNER_VIEW } from '@/components/loop-planner/common/lib/plannerViews';
import { getLastViewedScenarioView } from '@/lib/utils/planner/lastViewedScenarioView';

export const Route = createFileRoute('/(app)/org/$org/loop/$loopId/planner/scenario/$scenarioId/')({
  preloadStaleTime: 0,
  beforeLoad: ({ params }) => {
    const lastView = getLastViewedScenarioView(params.scenarioId);
    throw redirect({
      to: `/org/$org/loop/$loopId/planner/scenario/$scenarioId/${lastView ?? DEFAULT_PLANNER_VIEW}`,
      params,
    });
  },
});
